<main>
  <div class="summary-card">
    <div class="change-text">Change since last week</div>
    <div class="summary-grid">
      <div class="summary-item-top">
        <div class="value">1855<span class="unit">kW</span></div>
        <div class="change positive">
          <span class="arrow up"></span> +3.84%
        </div>
        <div class="label">Installed Capacity</div>
      </div>
      <div class="summary-item-top">
        <div class="value">{{ totalConsumers }}</div>
        <div class="change positive">
          <span class="arrow up"></span> +4.84%
        </div>
        <div class="label">Consumers</div>
      </div>
      <div class="summary-item-top">
        <div class="value">{{ totalProsumers }}</div>
        <div class="change negative">
          <span class="arrow down"></span> -2.84%
        </div>
        <div class="label">Prosumers</div>
      </div>
      <div class="summary-item-top">
        <div class="value">{{ totalProsumers + totalConsumers }}</div>
        <div class="change positive">
          <span class="arrow up"></span> +1.03%
        </div>
        <div class="label">Total Users</div>
      </div>
    </div>
  </div>

  <div class="status-section">
    <div class="Line">
      <div class="left-line"></div>
      <h2>New Application Status</h2>
      <div class="right-line"></div>
    </div>
    <div class="status-grid">
      <div *ngFor="let element of applicationsStates" class="status-item" (click)="goToApplicationsReceived(element.id)">
        <div class="value">{{ element.count }}</div>
        <div class="label">{{ element.states }}</div>
        <div *ngIf="element.description != ' '" class="sublabel">({{ element.description }})</div>
      </div>
    </div>
  </div>
</main>
